/** Website administration is reserved to the employee admin role, without a developer bypass. */
export function canAccessWebsite(role: string | null | undefined): boolean {
  return role === 'studio_admin';
}
